import { render, staticRenderFns } from "./InfoTagPopup.vue?vue&type=template&id=29bd434a&scoped=true"
import script from "./InfoTagPopup.vue?vue&type=script&lang=js"
export * from "./InfoTagPopup.vue?vue&type=script&lang=js"
import style0 from "./InfoTagPopup.vue?vue&type=style&index=0&id=29bd434a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bd434a",
  null
  
)

export default component.exports